'use client';

import { forwardRef } from 'react';
import clsx from 'clsx';
import type { SectionHeaderProps } from './types';

const SectionHeader = forwardRef<HTMLDivElement, SectionHeaderProps>(function SectionHeader(
    { title, subtitle, showLine = true, className, classNames = {} },
    ref
) {
    const { root, title: titleClass, line, subtitle: subtitleClass } = classNames;
    return (
        <div ref={ref} className={clsx(root, className)}>
            <h2 className={clsx(titleClass)}>{title}</h2>
            {showLine && <div className={clsx(line)} aria-hidden />}
            {subtitle != null && <p className={clsx(subtitleClass)}>{subtitle}</p>}
        </div>
    );
});

export default SectionHeader;
